import { Clickable, Row, Text } from 'components';
import { closeNotifs, theme } from 'lib';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const MedText = (props) => <Text {...props} med />;

const CONTENT_LABEL_KEYS = {
  Post: 'post',
  Comment: 'comment',
  FanChat: 'fanChat',
  Shoutout: 'shoutout',
  FanCamPhoto: 'fanCamPhoto',
  Story: 'story',
  ProfileDescription: 'profileDescription',
  Username: 'username',
  ProfileImage: 'profileImage'
};

/**
 * System moderation notice (no sender): a takedown (type contentRemoved) or a
 * borderline-content warning (type moderationWarning). A warning links to the
 * user's own profile, where the published content lives.
 */
const ModerationNotice = ({ data }) => {
  const { type, timestamp, destination, reasonLabel } = data;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const content = t(`notifications.moderatedContent.${CONTENT_LABEL_KEYS[destination] || 'content'}`);
  const baseKey = type === 'contentRemoved' ? 'contentRemoved' : 'contentWarned';
  const message = reasonLabel
    ? t(`notifications.${baseKey}`, { content, reason: reasonLabel })
    : t(`notifications.${baseKey}NoReason`, { content });

  // Removed content resolves nowhere; warned content is on the user's profile.
  const clickable = type === 'moderationWarning' && user?.username;

  const handleClick = () => {
    if (!clickable) return;
    navigate(`/profile/${user.username}`);
    closeNotifs(dispatch);
  };

  const row = (
    <Row noFlex pad="0 0 16px" between center>
      <Trans
        parent={MedText}
        style={{ flex: 1 }}
        components={{ strong: <strong style={{ fontWeight: 700 }} /> }}
      >
        {message}
      </Trans>
      <Text b2 med col={theme.GREY_60} style={{ marginLeft: 8, whiteSpace: 'nowrap' }}>
        {timestamp}
      </Text>
    </Row>
  );

  return clickable ? <Clickable onClick={handleClick}>{row}</Clickable> : row;
};

export default ModerationNotice;
